import React, { ReactNode } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { FORM_ERROR } from 'final-form';
import { MemberDTO } from '../../../../../network/api/types/compte/MemberDTO';
import photoMadame from '../../../../../img/cartouche_femme.png';
import photoMonsieur from '../../../../../img/cartouche_homme.png';
import editButton from '../../../../../img/icones/modifier.svg';
import chevronDroite from '../../../../../img/icones/chevron_droite.svg';
import { CompteProfilProProfileDetails } from '../../../../../network/api/types/compte/CompteProfilProProfileDetails';
import compteApi from '../../../../../network/api/compteApi';
import {
  CompteEntitesMemberProfessionalInfosModifyDTO,
  StatutEnum,
} from '../../../../../network/api/types/compte/CompteEntitesMemberProfessionalInfosModifyDTO';
import { notifyErrorWithMessage, notifySuccess } from '../../../../common/Notification';
import Button from '../../../../common/Button';
import { ErrorDTO } from '../../../../../network/api/types/compte/ErrorDTO';
import { FieldErrorDTO } from '../../../../../network/api/types/compte/FieldErrorDTO';
import CollaboratorsModifyModal, { FormValues } from './CollaboratorsModifyModal';

type Props = {
  domaines: string[]
  entityId: string
  member: MemberDTO
  refresh: () => void
  hidden: boolean
  isManager: boolean
};

type State = {
  profileDetail: CompteProfilProProfileDetails
  isModalOpen: boolean
  isExpanded: boolean
  photo: string
  civilite?: string,
};

class CollaboratorsTile extends React.Component<Props, State> {
  state: State = {
    profileDetail: null,
    isModalOpen: false,
    isExpanded: false,
    photo: '',
    civilite: undefined,
  };

  openModal = (): void => {
    this.setState((prevState: State) => ({ isModalOpen: !prevState.isModalOpen }));
  };

  componentDidMount(): void {
    const idnMembre = this.props.member.idn;
    const entityID = this.props.entityId;
    compteApi.getProfilePro(`${idnMembre}_${entityID}`)
      .then((profileDetail) => this.setState({ profileDetail }));
    compteApi.fetchEntityMemberPersonalInfos(idnMembre, entityID)
      .then((memberPersonalInfos) => this.setState({
        photo: memberPersonalInfos.photo,
        civilite: memberPersonalInfos.civilite,
      }));
  }

  handleEdit = async (values: FormValues): Promise<{ [FORM_ERROR]: FieldErrorDTO[] }> => {
    try {
      const idnMembre = this.props.member.idn;
      const entityID = this.props.entityId;
      const idnRattachementMembre = `${idnMembre}_${entityID}`;
      const statut = values.statut;
      const domaines = values.domaines || [];
      if (this.props.domaines.includes(values.domainesSelect)
        && !domaines.includes(values.domainesSelect)) {
        domaines.push(values.domainesSelect);
      }
      const dto: CompteEntitesMemberProfessionalInfosModifyDTO = {
        idnMembre,
        idnRattachementMembre: `${idnMembre}_${entityID}`,
        domaineDactivite: domaines,
        statut,
        mandat: null,
        email: values.email || '',
        telephoneFixe: values.telephoneFixe || '',
        telephoneMobile: values.telephoneMobile || '',
      };

      return compteApi.modifyMemberProInfo(dto)
        .then(() => {
          this.props.refresh();
          compteApi.getProfilePro(idnRattachementMembre)
            .then((profileDetail) => this.setState({ profileDetail }));
        })
        .then(() => notifySuccess(I18n.t('message.SUCCESS')))
        .then(this.openModal)
        .catch((err) => {
          if (typeof err.then === 'function') {
            return err.then((e: ErrorDTO) => ({ [FORM_ERROR]: e.fieldErrors }));
          }
          notifyErrorWithMessage(I18n.t('message.ERROR_MODIF'));
          return null;
        });
    } catch (err) {
      return { [FORM_ERROR]: [] };
    }
  };

  toggleExpand = (): void => {
    this.setState((prevState) => ({ isExpanded: !prevState.isExpanded }));
  };

  render(): ReactNode {
    if (this.props.hidden) {
      return false;
    }
    const member = this.props.member;
    const photo = this.state.photo || (this.state.civilite === 'Madame' ? photoMadame : photoMonsieur);
    return (
      <>
        <div>
          <div
            className={`collaborator-tile${this.state.isExpanded ? ' open' : ''}${this.state.isModalOpen ? ' modal-open' : ''}`}
            onClick={() => {
              this.toggleExpand();
            }}
          >
            <CollaboratorsModifyModal
              selectedDomaines={this.state.profileDetail?.domaineDactivite || []}
              domaines={this.props.domaines}
              photo={photo}
              member={member}
              isOpen={this.state.isModalOpen}
              openModal={this.openModal}
              handleEdit={this.handleEdit}
            />
            <div className="collab-photo">
              <img
                src={photo}
                alt="zz"
              />
            </div>
            <div className="collab-info-column first">
              <div className="collab-appelation">
                <span>{member.prenom}</span>
                <span>{member.nomUsuel}</span>
              </div>
              <span>{/* NOMDENAISSANCE */}</span>
              <div className="collab-fonction">
                <span className="blue-field">{member.fonction}</span>
                {member.fonction?.toLowerCase().includes('collaborateur')
                && <span className={`${member.statut ? 'blue-field' : 'red-field'}`}>{member.statut ? member.statut.toLowerCase() : 'Profil à compléter'}</span>}
              </div>
            </div>
            <div className="chevron-mobile">
              <img
                className={`chevron ${this.state.isExpanded ? 'face-up' : 'face-bottom'}`}
                src={chevronDroite}
                alt="chevron"
              />
            </div>
            <div className="collab-info-column second">
              <div>
                <Translate className="collab-info-title" value="COLLABORATORS_INFORMATION.DOMAIN" />
                <div className="domaine-list">
                  <span>
                    {this.state.profileDetail?.domaineDactivite
                    .sort((domainA, domainB) => domainA.localeCompare(domainB))
                    .join(', ') || (<Translate value="COLLABORATORS_INFORMATION.NO_INFO" />)}
                  </span>
                  {this.state.profileDetail
                  && (this.state.profileDetail.domaineDactivite.length > 1) && (
                  <div className="tooltip">
                    <div className="arrow-up" />
                    <div className="tooltip-content">
                      {this.state.profileDetail?.domaineDactivite
                        .sort((domainA, domainB) => domainA.localeCompare(domainB))
                        .join(', ') || (<Translate value="COLLABORATORS_INFORMATION.NO_INFO" />)}
                    </div>
                  </div>
                  )}
                </div>
              </div>
              <div>
                <Translate className="collab-info-title" value="COLLABORATORS_INFORMATION.MAIL_PRO" />
                <span>
                  {member.email
                    ? (<a onClick={(e) => e.stopPropagation()} href={`mailto:${member.email}`}>{member.email}</a>)
                    : (<Translate value="COLLABORATORS_INFORMATION.NO_INFO" />)}
                </span>
              </div>
            </div>
            <div className="collab-info-column">
              <div>
                <Translate className="collab-info-title" value="COLLABORATORS_INFORMATION.TEL_FIXE" />
                <span>
                  {member.telephoneFixe
                    ? (<a onClick={(e) => e.stopPropagation()} href={`tel:${member.telephoneFixe}`}>{member.telephoneFixe}</a>)
                    : (<Translate value="COLLABORATORS_INFORMATION.NO_INFO" />)}
                </span>
              </div>
              <div>
                <Translate className="collab-info-title" value="COLLABORATORS_INFORMATION.TEL_MOBILE" />
                <span>
                  {member.telephoneMobile
                    ? (<a onClick={(e) => e.stopPropagation()} href={`tel:${member.telephoneMobile}`}>{member.telephoneMobile}</a>)
                    : (<Translate value="COLLABORATORS_INFORMATION.NO_INFO" />)}
                </span>
              </div>
            </div>
            {this.props.isManager
            && !this.props.member.gestionnaireNaturel
              ? (
                <div className="collab-info-column">
                  <button
                    className="collab-info-modify-button"
                    type="button"
                    onClick={this.openModal}
                  >
                    <img
                      src={editButton}
                      alt="edit-collab-button"
                    />
                  </button>
                </div>
              ) : <div className="collab-info-column" />}
          </div>
          <div className={`expanded-collaborator-tile${this.state.isExpanded ? ' open' : ''}`}>
            <div className="expanded-collaborator-info">
              <div className="collab-info-column">
                <div>
                  <Translate className="collab-info-title" value="COLLABORATORS_INFORMATION.DOMAIN" />
                  <span>
                    {this.state.profileDetail?.domaineDactivite
                      .sort((domainA, domainB) => domainA.localeCompare(domainB))
                      .join(', ') || (<Translate value="COLLABORATORS_INFORMATION.NO_INFO" />)}
                  </span>
                </div>
                <div>
                  <Translate className="collab-info-title" value="COLLABORATORS_INFORMATION.MAIL_PRO" />
                  <span>
                    {member.email
                      ? (<a onClick={(e) => e.stopPropagation()} href={`mailto:${member.email}`}>{member.email}</a>)
                      : (<Translate value="COLLABORATORS_INFORMATION.NO_INFO" />)}
                  </span>
                </div>
              </div>
              <div className="collab-info-column">
                <div>
                  <Translate className="collab-info-title" value="COLLABORATORS_INFORMATION.TEL_FIXE" />
                  <span>
                    {member.telephoneFixe
                      ? (<a onClick={(e) => e.stopPropagation()} href={`tel:${member.telephoneFixe}`}>{member.telephoneFixe}</a>)
                      : (<Translate value="COLLABORATORS_INFORMATION.NO_INFO" />)}
                  </span>
                </div>
                <div>
                  <Translate className="collab-info-title" value="COLLABORATORS_INFORMATION.TEL_MOBILE" />
                  <span>
                    {member.telephoneMobile
                      ? (<a onClick={(e) => e.stopPropagation()} href={`tel:${member.telephoneMobile}`}>{member.telephoneMobile}</a>)
                      : (<Translate value="COLLABORATORS_INFORMATION.NO_INFO" />)}
                  </span>
                </div>
              </div>
            </div>
            {this.props.isManager
              && !this.props.member.gestionnaireNaturel
            && (
              <div className="collab-info-column">
                <Button
                  className="collab-info-modify-button"
                  type="secondary"
                  onClick={this.openModal}
                >
                  <Translate value="COLLABORATORS_INFORMATION.EDIT" />
                </Button>
              </div>
            )}
          </div>
        </div>
        <div className="drawer-divider-horizontal nofill" />
      </>
    );
  }
}

export default CollaboratorsTile;
